import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCta() {
  return <section id="precio-final" className="bg-charcoal py-24 px-6 md:px-12 text-center" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-41">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-8 leading-tight" data-id="element-42">
            Dejá de pelearte con la cocina y empezá a disfrutar de tu
            tecnología.
          </h2>

          <p className="font-sans text-lg md:text-xl text-cream/80 mb-10" data-id="element-43">
            Llevate el método completo "AirFryer Criolla Express" hoy mismo.
          </p>

          <div className="mb-8" data-id="element-44">
            <span className="font-sans text-cream/40 line-through text-xl md:text-2xl mr-3" data-id="element-45">
              $12.99
            </span>
            <span className="font-serif font-bold text-amber text-5xl md:text-6xl" data-id="element-46">
              $6.39
            </span>
            <span className="block font-sans text-amber-light text-sm mt-2 tracking-wide uppercase" data-id="element-47">
              Precio de lanzamiento — 50% OFF
            </span>
          </div>

          <Button className="mb-6 w-full md:w-auto md:px-12 py-5 text-xl" onClick={e => {
          e.stopPropagation();
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'AirFryer Criolla Express',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
          window.open('https://cocinandoconjoha.com/cart/47712627490981:1', '_blank');
        }} data-id="element-48">
            ¡QUIERO MI COPIA AHORA!
          </Button>

          <p className="font-sans text-sm text-cream/50" data-id="element-49">
            Acceso inmediato tras el pago. Comé rico hoy mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}